import { Injectable } from '@angular/core';
import { cloneDeep, isArray } from 'lodash';
import { SclSearchClientConstantService } from '@formbird/services';
import { sclHandlebars } from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
@Injectable({
  providedIn: 'root'
})
export class RelatedDocumentQueries {

  constructor() { }

  processElasticQuery(self, text, isOnClick?) {
    const vm = self;

    if (vm.componentDefinition.filter) {
      const filter = this.processHandlebars(vm);

      if (typeof filter === 'string') {
        vm.options.filter = JSON.parse(filter.replace(/'/g, '"'));
      } else {
        vm.options.filter = filter;
      }

      if (vm.options.filter.query.bool.should === undefined) {
        vm.options.filter.query.bool.should = [];
      }
      if (vm.options.filter.query.bool.must instanceof Object && vm.options.filter.query.bool.must.constructor === Object) {
        const objMust = vm.options.filter.query.bool.must;
        vm.options.filter.query.bool.must = [];
        vm.options.filter.query.bool.must.push(objMust);
      } else {
        if (vm.options.filter.query.bool.must === undefined) {
          vm.options.filter.query.bool.must = [];
        }
      }
      if (!isOnClick) {
        // Add wildcard to query filter 'systemHeader.summaryName'
        let textSearch = '';
        if (text) {
          vm.options.filter.query.bool.must = this.getObjectNotWildcardSummaryName(vm.options.filter.query.bool.must);
          if(text.name){
            textSearch = text.name.toLowerCase();
          }else{
            textSearch = text.toLowerCase();
          }
          vm.options.filter.query.bool.must.push({ wildcard: { 'systemHeader.summaryName.lcase': '*' + textSearch + '*' } });

        }
      } else {
        if (vm.componentDefinition.uniqueSelection) {
          if (vm.options.filter.query.bool.must_not === undefined) {
            vm.options.filter.query.bool.must_not = [];
          }
          if ((vm.document[vm.componentDefinition.name] && vm.document[vm.componentDefinition.name].length >= 1)) {
            const resultData = cloneDeep(vm.document[vm.componentDefinition.name]);
            resultData.map(doc => {
              if (doc.documentId) {
                vm.options.filter.query.bool.must_not.push({ term: { documentId: doc.documentId } });
              }
              if (doc._source) {
                if (doc._source.documentId) {
                  vm.options.filter.query.bool.must_not.push({ term: { documentId: doc._source.documentId } });
                }
              }
            });
          }
        }
      }

    }
  }

  processDexieQuery(self, text, isOnClick) {
    const vm = self;
    if (!vm.options.filter) {
      vm.options.filter = {};
    }

    if (!isOnClick) {
      // Add wildcard to query filter 'systemHeader.summaryName'
      if (text) {
        const query = isArray(vm.options.filter.dexieQuery) ? vm.options.filter.dexieQuery : [];
        let i;
        let isFound = false;
        for (i = 0; i < query.length; i++) {
          if (query[i].field === 'systemHeader.summaryName') {
            query[i].value = text.toLowerCase();
            query[i].operator = SclSearchClientConstantService.operator.contains;
            isFound = true;
            break;
          }
        }
        if (!isFound) {
          query.push({
            field: 'systemHeader.summaryName', value: text.toLowerCase(),
            operator: SclSearchClientConstantService.operator.contains
          });
        }
        vm.options.filter.dexieQuery = query;
      }
    } else {
      if (vm.componentDefinition.uniqueSelection) {
        vm.options.filter.dexieQuery = !isArray(vm.options.filter.dexieQuery) ? [] : vm.options.filter.dexieQuery;
        if ((vm.document[vm.componentDefinition.name] && vm.document[vm.componentDefinition.name].length >= 1)) {
          const resultData = cloneDeep(vm.document[vm.componentDefinition.name]);
          resultData.map(doc => {
            if (doc.documentId) {
              vm.options.filter.dexieQuery.push({
                field: 'documentId', value: doc.documentId,
                operator: SclSearchClientConstantService.operator.notEquals
              });
            }
            if (doc._source) {
              if (doc._source.documentId) {
                vm.options.filter.dexieQuery.push({
                  field: 'documentId', value: doc._source.documentId,
                  operator: SclSearchClientConstantService.operator.notEquals
                });
              }
            }
          });
        }
      }
    }
  }

  private processHandlebars(vm) {
    const handlebarsContext = {
      document: vm?.document,
      doc: vm?.document,
      account: vm?.loggedInUserService?.user?.account, // the account document from scope
      tpl: vm?.template,
      template: vm?.template,
      componentDefinition: vm?.componentDefinition // the current components configuration details
    };
    return sclHandlebars.processHandlebars(vm.componentDefinition.filter, null, handlebarsContext);
  }

  getObjectNotWildcardSummaryName(mustObject) {
    const mustSelected = [];
    mustObject.map((key, index) => {
      let isFoundSummaryName = false;
      if (key.wildcard) {
        for (const sss in key.wildcard) {
          if (sss === 'systemHeader.summaryName.lcase') {
            isFoundSummaryName = true;
          } else {
            isFoundSummaryName = false;
          }
        }
      } else {
        isFoundSummaryName = false;
      }
      if (!isFoundSummaryName) {
        mustSelected.push(mustObject[index]);
      }
    });
    return mustSelected;
  }

}

